import { defineMessages } from 'react-intl';

export default defineMessages({
    loading: {
        id: 'ent.offerdetails.paymentmethod.Loading',
        defaultMessage: 'Loading...'
    },
    selectAutomaticPaymentMethod: {
        id: 'billing.paymentMethod.Select Automatic Payment Method',
        defaultMessage: 'Select Automatic Payment Methods',
    },
    editAutoPay: {
        id: 'billing.paymentMethod.Edit Auto Pay',
        defaultMessage: 'Edit Auto Pay',
    },
    setupAutoPay: {
        id: 'billing.paymentMethod.Setup Auto Pay',
        defaultMessage: 'Setup Auto Pay',
    },
    editAutomaticPaymentMethod: {
        id: 'billing.paymentMethod.Edit Automatic Payment Method',
        defaultMessage: 'Edit Automatic Payment Method',
    },
    selectPaymentMethod: {
        id: 'billing.paymentMethod.Select Payment Method',
        defaultMessage: 'Select Payment Method',
    }
});
